"use client";
import React, { useEffect, useState } from "react";
// import LikeButton from "./likeButton"; // Import LikeButton component here
import { Copy, FileDown, FolderPlus, Heart, Share } from "lucide-react";
import { useShareModal } from "./share-modal";
import { findStyleName } from "../shared/generators/generators";
import { likePost, unlikePost } from "@/lib/api/post";
import { siteConfigurations } from "../shared/sites/sites";
import { useGlobalContext } from "@/app/context/store";
import { useSignInModal } from "../layout/sign-in-modal";
import { useReportModal } from "./reportModal";
import AddToAlbumModal from "./addToAlbumModal";
import axios from "axios";
// import { Sign } from "crypto";

const shouldShowPost = (status: string) => status === "none" || status === "approved";

const ImageComponent = ({
  action,
  _id,
  type = "image",
  reviewStatus,
  translations,
  modalTranslations,
  signInModalTranslations,
  reportModalTranslations,
  shareModalTranslations,
}: {
  action: any;
  _id: string;
  type?: "image" | "gif";
  reviewStatus: string;
  translations: any;
  modalTranslations: any;
  signInModalTranslations: any;
  reportModalTranslations: any;
  shareModalTranslations: any;
}) => {
  const [downloading, setDownloading] = useState(false);
  // const [likes, setLikes] = useState(action.post.likes || 0);
  const [liked, setLiked] = useState(false);
  const [isAddToAlbumOpen, setIsAddToAlbumOpen] = useState(false);
  const { user } = useGlobalContext();
  const { ShareModal, setShowShareModal } = useShareModal(shareModalTranslations);

  const { ReportModal, setShowReportModal } = useReportModal(reportModalTranslations);

  const { SignInModal, setShowSignInModal } = useSignInModal(signInModalTranslations);

  const downloadImage = async (url: string) => {
    if (user._id === "none") {
      // window.alert(locale.accessViaAccount);
      setShowSignInModal(true);
    } else {
      setDownloading(true);

      const response = await axios.get(url + "?original=1", {
        responseType: "blob",
      });
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = `${_id}.${url.endsWith(".png") ? "png" : "jpg"}`;
      link.click();

      // Release the reference to the object URL after the download starts
      URL.revokeObjectURL(objectUrl);

      setDownloading(false);
    }
  };

  const handleClick = () => {
    if (user._id === "none") {
      setShowSignInModal(true);
      // window.alert(locale.accessViaAccount);
      return;
    }

    if (liked) {
      //@ts-ignore
      unlikePost(action.post._id);
    } else {
      //@ts-ignore
      likePost(action.post._id);
    }

    setLiked((prevLiked: any) => !prevLiked);
    // setLikes((prevLikes: number) => (!liked ? prevLikes + 1 : prevLikes - 1));
  };

  const handleCloneClick = () => {
    if (user._id === "none") {
      // window.alert(locale.accessViaAccount);
      setShowSignInModal(true);
    } else {
      let newCustomPrompt = action.post.customPrompt || "";
      // if (newCustomPrompt !== "" && newCustomPrompt !== undefined) {
      //   let lastCommaIndex = newCustomPrompt.lastIndexOf(",");
      //   if (lastCommaIndex !== -1) { // Check if there is a comma
      //     newCustomPrompt = newCustomPrompt.substring(0, lastCommaIndex);
      //   }
      // }
      const cloneUrl =
        process.env.NEXT_PUBLIC_BASE_URL +
        action.localePath +
        "/create?style=" +
        action.style +
        "&resolution=" +
        action.post?.aspectRatio +
        "&tags=" +
        action.tagIds +
        "&prompt=" +
        encodeURIComponent(newCustomPrompt);
      window.location.href = cloneUrl; // Redirects the user to the cloneUrl
    }
  };

  useEffect(() => {
    setLiked(action.post?.userLiked);
  }, [action.post?.userLiked]);

  return (
    <div className="mb-auto w-auto border-[0.5px] border-b-0 border-[#3C3C3C] bg-[#2B2D31] shadow-md sm:rounded-tl-md sm:rounded-tr-md">
      <ShareModal />
      <ReportModal />
      <SignInModal />
      <AddToAlbumModal
        showAddToAlbumModal={isAddToAlbumOpen}
        setShowAddToAlbumModal={setIsAddToAlbumOpen}
        postIds={[_id]}
        translations={{
          addToAlbum: modalTranslations.addToAlbum,
          albumName: modalTranslations.albumName,
          albumDescription: modalTranslations.albumDescription,
          cancel: modalTranslations.cancel,
          create: modalTranslations.create,
          add: modalTranslations.add,
          createAlbum: modalTranslations.createAlbum,
          added: modalTranslations.added,
        }}
        signInModalTranslations={signInModalTranslations}
        contentType={type}
      />
      <div className="flex w-full flex-row bg-[#2B2D31] px-3 backdrop-blur-xl sm:rounded-md">
        <button
          onClick={() => handleClick()}
          className={`m-2 flex flex-row items-center justify-center rounded-full ${
            liked ? "bg-[#DD0772]" : "bg-[#4d4f59]"
          } px-1 py-1.5 backdrop-blur-xl hover:bg-[#DD0772] hover:brightness-105`}
          disabled={!shouldShowPost(reviewStatus)}
        >
          <Heart
            color="white"
            className="mx-2 h-4 w-auto sm:ml-2 sm:mr-1"
            fill={liked ? "#ffffff" : "none"}
          />
          <div className="ml-1 mr-2 hidden truncate text-xs text-white sm:block">
            {translations.save}
          </div>
        </button>

          <button
            className="m-2 flex flex-row items-center justify-center rounded-full bg-[#4d4f59] px-1 py-1.5 backdrop-blur-xl hover:bg-[#DD0772] hover:brightness-105"
            onClick={() => {
              if (user._id === "none") {
                setShowSignInModal(true);
              } else {
                setIsAddToAlbumOpen(true);
              }
            }}
            disabled={!shouldShowPost(reviewStatus)}
          >
            <FolderPlus color="white" className="mx-2 h-4 w-auto sm:ml-2 sm:mr-1" />
            <div className="ml-1 mr-2 hidden max-w-[100px] truncate text-xs text-white sm:block">
              {modalTranslations.addToAlbum}
            </div>
          </button>

        <button
          className="m-2 flex flex-row items-center justify-center rounded-full bg-[#DD0772] px-1 py-1.5 backdrop-blur-xl hover:brightness-105"
          onClick={() => setShowShareModal(true)}
          disabled={!shouldShowPost(reviewStatus)}
        >
          <Share color="white" className="mx-2 h-4 w-auto sm:ml-2 sm:mr-1" />
          <div className="ml-1 mr-2 hidden truncate text-xs text-white sm:block">
            {translations.share}
          </div>
        </button>

        <button
          aria-label="Download"
          className="m-2 ml-auto flex flex-row items-center justify-center rounded-full bg-[#DD0772] px-1 py-1.5 backdrop-blur-xl hover:brightness-105"
          onClick={() => downloadImage(action.post.imageUrl)}
          disabled={downloading || !shouldShowPost(reviewStatus)}
        >
          <FileDown aria-label="Download" color="white" className="mx-2 h-4 w-auto" />
        </button>
      </div>
      <div className="border-t-[0.5px] border-[#3C3C3C] pt-4">
        <div className="flex flex-row px-5 pb-4">
          {(process.env.NEXT_PUBLIC_BASE_URL === "http://localhost:3000" ||
          process.env.NEXT_PUBLIC_BASE_URL === "https://www.8porn.ai"
            ? true
            : siteConfigurations[action.post?.origin]?.siteUrl ===
              process.env.NEXT_PUBLIC_BASE_URL) && (
            <div className="my-auto text-sm font-medium text-white">
              {findStyleName(translations.key, action.style) ?? action.style}
            </div>
          )}
          {(process.env.NEXT_PUBLIC_BASE_URL === "http://localhost:3000" ||
          process.env.NEXT_PUBLIC_BASE_URL === "https://www.8porn.ai"
            ? false
            : siteConfigurations[action.post?.origin]?.siteUrl !==
              process.env.NEXT_PUBLIC_BASE_URL) && (
            <div className="text-sm font-medium text-white">
              {translations.madeWith}
              <a
                href={
                  siteConfigurations[action.post?.origin]?.siteUrl +
                    translations.path +
                    "post/" +
                    action.post?._id || "https://www.createporn.com"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="mx-1 text-white underline"
              >
                {siteConfigurations[action.post?.origin]?.siteName || "CreatePorn"}
                .com
              </a>
            </div>
          )}
          <button
            className="my-auto ml-auto text-sm font-medium text-[#3796F6]"
            onClick={() => setShowReportModal(true)}
          >
            {translations.report}
          </button>
          {type !== "gif" && (
            <>
              {(process.env.NEXT_PUBLIC_BASE_URL === "http://localhost:3000" ||
              process.env.NEXT_PUBLIC_BASE_URL === "https://www.8porn.ai"
                ? true
                : siteConfigurations[action.post?.origin]?.siteUrl ===
                  process.env.NEXT_PUBLIC_BASE_URL) && (
                <button
                  className={`ml-4 flex flex-row items-center justify-center rounded-full bg-[#0772DD] px-1 py-1.5 backdrop-blur-xl hover:brightness-105`}
                  onClick={() => {
                    // console.log(action.post.generator)
                    handleCloneClick();
                  }}
                  disabled={!shouldShowPost(reviewStatus)}
                >
                  <Copy color="white" className="my-auto ml-2 h-3 w-auto" />
                  <div className="mx-2 text-xs text-white">{translations.cloneTags}</div>
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageComponent;
